// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:44:23+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fa013d1fb1c796f27c6d200a192d0a96
//    Signature:      eyJpdiI6IlwvTlRWdnVMblwvdVc5dG1kUGMxUkFMQT09IiwidmFsdWUiOiJsVjV6Z0ZEUUxOeUs0OGN3V0l6VXVmcFZ1ek0ya0lmTUJkanRYcmkrT0RoaVwvUFpGdUdIcWt2WTVqbWNNdXpHeHZCckJCYkhwbElrdG93OHI4VzExT1wveitsT0UxdW81VFFaN0xINVRKb00xMlJaQWZtTEJnaW1vMU8zczN5WEhRK1JteTRaUGVYNnNjbHJvWHNyajFoeWxWXC9tS1I2TThGNUgwT0JRSFFkNDdWUDJDbWQ4eHdFaWxcL2dRXC9hTGpcL3dzMUdzNkluXC9HcE5rK2FGM3RvamlmZEpUMzlKUVowdHhBNmQrOGk3ZWNcL2p2YjFGM1BTN3VyMGM3eVFJSENHdk45T01yZDhvTk10bVFNT2d3eWNpTWVveTdDSG01VjRsRUVXcmVLUERnYU0yck5ERTYrQTMyVFRqbUJmVkFBc0ZTTHVXV09TcTlyQ1J0K3NXa2ZqWjBTTFBwMm5FOWxhVEpxSk1jWVwvWjdpQzRNSUZVV0tOR2s5R3BcL0FOVG5VME9QTDNFTjEwbUNkYWFjUHFYWXF4dzJvdz09IiwibWFjIjoiNDMzZDM4YWQyZDI2MzMwMTE2NDFkOTA2ODA3YjM4M2M5NWJhMjhiYWZiMTEwMWU4YTU5ZTY4Y2RmOGZhZTczYiJ9
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
